import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import ResetPasswordFormPage from './form'
import ResetPasswordSuccessPage from './success'
import ResetPasswordErrorPage from './error'

const ResetPassword = () => {
  const [showEnd, setShowEnd] = useState(false)
  const { username, code } = useParams()

  const handleOnfinalize = (value) => {
    setShowEnd(value)
  }
  return (
    <>
      {!showEnd
        ? <ResetPasswordFormPage onFinalize={handleOnfinalize} username={username} code={code} />
        : showEnd === 'success' ? <ResetPasswordSuccessPage /> : <ResetPasswordErrorPage />}
    </>
  )
}
export default ResetPassword
